import { Component, OnInit } from '@angular/core';
import { ADPResourceService as ResourceService } from 'digital-core';

@Component({
  selector: 'gsp-edit-resource',
  templateUrl: './edit-resource.component.html',
  styleUrls: ['./edit-resource.component.css']
})
export class EditResourceComponent implements OnInit {
  editMode: Boolean;
  editModeVisible: Boolean;
  
  constructor(public resourcesService:ResourceService) { }

  ngOnInit() {
    this.editMode = this.resourcesService.isEditMode;

  }
  toggleEdit() {
    this.resourcesService.toggleEditMode();
  }
  


}
